// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("./components/image/appointmentbk.jpeg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Montserrat+Alternates:wght@100;200;500&family=Roboto+Condensed:wght@100;500&display=swap);"]);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Roboto+Condensed:ital,wght@0,100..900;1,100..900&display=swap);"]);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Inter:wght@400;700&display=swap);"]);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Poppins:wght@100;200;300;400;500;600;700;800;900&display=swap);"]);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `* {
  font-family: 'Poppins', sans-serif;
  box-sizing: border-box;
  font-size: 16px !important;

}



.p-card{
  color: white !important;;
}

h1,h2 {
  font-family: 'Poppins', sans-serif;
  font-weight: 500;
  box-sizing: border-box;
  font-size: 50px !important;


}


.events {
  margin: 0;
  padding: 0;
  list-style: none;
}
.events .ant-badge-status {
  width: 100%;
  overflow: hidden;
  font-size: 12px;
  white-space: wrap;
  text-overflow: ellipsis;
  text-align: center;
}
.notes-month {
  font-size: 28px;
  text-align: center;
}
.notes-month section {
  font-size: 28px;
}

.ant-rate {
  gap: 1px !important;
}

.ant-rate .ant-rate-star {
  margin-inline-end: 1px !important;
}

.ant-rate {
  margin-right: 2px !important;
}


:where(.css-dev-only-do-not-override-7ny38l).ant-btn-color-primary{
  background: #379777!important;
    box-shadow: 0 2px 0 rgba(5, 145, 255, 0.1);
}



:where(.css-dev-only-do-not-override-7ny38l).ant-btn-variant-link {
    color:white!important;
    box-shadow: none;
}







h2 {
  font-family: 'Poppins', sans-serif;
  font-weight: 500;
  box-sizing: border-box;
  font-size: 30px !important;


}


h3,h4,h5 {
   font-family: 'Poppins', sans-serif;
  font-weight: 500;
  box-sizing: border-box;
  font-size: 18px !important;


}

p {
   font-family: 'Poppins', sans-serif;
  font-weight: 400;
  box-sizing: border-box;

}

a{
   font-family: 'Poppins', sans-serif;
  font-weight: 500;
  box-sizing: border-box;
  font-size: 18px !important;
}

input {
   font-family: 'Poppins', sans-serif;
  box-sizing: border-box;
}


html, body {
  margin: 0;
  padding: 0;
  width: 100%;
  height: 100%;
  overflow: hidden; /* Prevents scrolling on the whole page */

}




/* Common styling */
.cards-title {
  font-size: 3em;
  font-weight: bold;
  margin-bottom: 0px;
}

.normal-text {
  font-size: 1rem;
}

.normal-text-doctor-speciality{
  font-size: 1rem;
  margin-top:-200px;

  
}

.card {
  box-shadow: 0 0 1px 1px rgba(0, 0, 0, 0.007);
  margin: 15px 0 !important;
  border-radius: 0px !important;
  padding: 10px 20px !important;
}

.cursor-pointer {
  cursor: pointer;
}

h1.card-t {
  font-size: 1.7rem;
  font-weight: 500;
  color: white !important;
}

.spinner-parent {
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: rgba(0, 0, 0, 0.452);
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 9999;
}

.spinner-border {
  width: 5rem;
  height: 5rem;
  color: white !important;
}

/* Authentication pages styling */






.auth {
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #1e2d3b !important;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___}); /* Replace with your image URL */
  background-size: cover;
  background-position: center;
  background-blend-mode:multiply; /* Choose the blend mode that suits your needs */
  opacity: 1.1; /* Adjust opacity as needed */
  overflow-y: auto;
}




.auth .card-title {
  font-size: 1em;
  background-color:  #217559!important;
  color:  #1e2d3b;
  max-width: max-content !important;
  padding:  7px 15px;
  margin-left: -40px;
  border-bottom-left-radius: 8px;
}

.cn {
  text-align: center !important;
}

.title {
  justify-content: center;
  margin: 0 auto;
  align-items: center;
}

.auth-form {
  width: 100%;
  max-width:450px;
  padding: 5px;
    background-color: #fafdff !important;
    border-radius: 5px !important;
}

/* antd overrides */
input {
  border-radius: 6px !important;
  height: 40px !important;
  width: 100% !important;
  padding: 0px 11px !important;
}

:where(.css-dev-only-do-not-override-dkbvqv).ant-input-affix-wrapper {
  border-radius: 0 !important;
  height:40px !important;
  padding: px 11px !important;
  
}

:where(.css-dev-only-do-not-override-1pg9a38).ant-input-affix-wrapper 
{
  border-radius: 0 !important;
  height: 40px !important;
  
  }

:where(.css-dev-only-do-not-override-1pg9a38).ant-input-affix-wrapper 

.ant-btn {
  border-radius: 0 !important;
  
}



:where(.css-dev-only-do-not-override-dkbvqv).ant-picker
  .ant-picker-input
  > input {
  border: 0px !important;
  color:  #1e2d3b !important;
  height: 50px !important;
  width: 100% !important;
}

.anchor {
  color:  #1e2d3b !important;
  font-size: 0.9rem !important;
  font-weight: 500 !important;
  text-decoration: underline !important;
  cursor: pointer;
}

:where(.css-dev-only-do-not-override-dkbvqv).ant-picker {
  height: 40px !important;
  width: 100% !important;
}

:where(.css-dev-only-do-not-override-dkbvqv).ant-btn-primary {
  background-color:  #1e2d3b !important;
  color: white !important;
}

.ant-picker {
  border-radius: 0px !important;
}

.ant-select-selector {
  border-radius: 0px !important;
}
/* input.ant-input{
  border:0px!important;
  border-radius: 0px !important;
  height:40px !important;
  background-color:transparent !important;
  font-size: 15px !important;
  color:rgb(24, 23, 23) !important;
  padding: 0px 3px !important;
 
}  */

.ant-select-selector {
  height: 50px !important;
  background-color: transparent !important;
  font-size: 15px !important;
  color: rgb(24, 23, 23) !important;
  padding: 0px 3px !important;

}

.ant-select-selection-search-input {
  border-radius: 0px !important;
  height: 50px !important;
  background-color: transparent !important;
  font-size: 15px !important;
  color: rgb(24, 23, 23) !important;
  padding: 0px 3px !important;

}

label {
  font-size: 1rem !important;
  font-weight: 400 !important;
  color:  #1e2d3b !important;
}

.ant-form-item {
  margin: 15px 0 !important;
}

.btn-primary {
  background-color: #217559!important;
  border-color:  #217559!important;
  color: white !important;
  font-weight: 500 !important;
  width: 100% !important;
  height: 40px !important;
  margin-top: 10px !important;
  margin-bottom: 10px !important;
  border-radius: 0 !important;
}

:where(.css-dev-only-do-not-override-1odpy5d).ant-btn-variant-solid {
    color: #fff;
   background-color: #217559!important;
  border-color:  #217559!important;
}


.btn-primary:hover {
  background-color: #1e2d3b !important;
  border-color: #1e2d3b !important;
  color:white !important;
}


.btn-2{

  border: none !important;
  color: #1e2d3b !important;
  font-weight: 500 !important;
  width: 100% !important;
  height: 40px !important;
  margin-top: 10px !important;
  margin-bottom: 10px !important;
  border-radius: 0 !important;

}

.btn-2:hover {
  background-color:  #1e2d3b !important;
  border-color:  #1e2d3b !important;
  color: white !important;
}

.formFactor {
  justify-content: space-between;
  align-items: center;
  margin: 0px 30px;
}

.mv {
  margin: 0 30px;
}

.page-header {
  margin: 0 30px;
}

.page-title {
  font-size: 0.9rem;
}

.card-title {
  font-size: 1rem;
  font-weight: 900;
  color: white !important;
}

p {
  color: rgba(0, 0, 0, 0.773) !important;
  margin: 3px !important;
  padding: 0 !important;
}

.pm{
  text-align: center!important;
  align-items: center!important;
}


.book-appointment-container {
  padding: 20px;
  max-width: 1200px;
  margin: auto;
}

.doctor-card {
  background: #f9f9f9;
  border-radius: 10px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  padding: 20px;
}

.book-now-img {
  border-radius: 10px;
  margin-bottom: 20px;
}

.descriptions {
  margin-bottom: 20px;
}

.date-time-picker {
  display: flex;
  align-items: center;
  margin-bottom: 10px;
  margin-top: 20px;
}

.button-group {
  display: flex;
  justify-content: space-between;
}


.ant-picker{
  width: 100%;
  height: 40px;
  margin-left: 6px;
  margin-right: 6px;
   border-radius: 6px !important;



}

@media (max-width: 768px) {
  .auth {
    padding-bottom: 2rem; /* space for content */
  }
}


.ant-select-selector {
  height: 40px !important;
  background-color: transparent !important;
  font-size: 15px !important;
  color: rgb(24, 23, 23) !important;
  border-radius: 6px !important;

}



:where(.css-dev-only-do-not-override-7ny38l).ant-btn-color-dangerous.ant-btn-variant-link{
  color: white !important;
  background-color: #f5222d !important;
  box-shadow: none !important;
  border-radius: 6px !important;
}


.appointment-report-container {
  padding: 20px;
  min-height: 100vh;
  background: #f0f2f5;
}

.page-header {
  margin-bottom: 24px;
}

.page-header h1 {
  margin: 0;
  color: #262626;
  font-size: 24px;
  font-weight: 600;
}

.page-header p {
  margin: 4px 0 0 0;
  color: #8c8c8c;
  font-size: 14px;
}

.controls-section {
  background: white;
  padding: 20px;
  border-radius: 8px;
  margin-bottom: 20px;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.03);
}

.table-section {
  background: white;
  padding: 20px;
  border-radius: 8px;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.03);
}

.comment-cell {
  max-width: 150px;
}

.comment-by {
  font-weight: 600;
  font-size: 12px;
  color: #1890ff;
  margin-bottom: 2px;
}

.comment-text {
  font-size: 11px;
  color: #666;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.action-display {
  font-size: 12px;
}

.action-info {
  display: flex;
  align-items: center;
  gap: 6px;
  margin-bottom: 4px;
}

.action-time {
  font-size: 11px;
  color: #999;
  padding-left: 20px;
}

.status-indicator {
  padding: 4px 8px;
  border-radius: 4px;
  font-size: 12px;
  font-weight: 500;
  display: inline-block;
}

.approved-status { 
  background: #f6ffed; 
  color: #52c41a; 
  border: 1px solid #b7eb8f; 
}

.rejected-status { 
  background: #fff2f0; 
  color: #ff4d4f; 
  border: 1px solid #ffccc7; 
}

.followup-status { 
  background: #f0f7ff; 
  color: #1890ff; 
  border: 1px solid #91d5ff; 
}

.completed-status { 
  background: #f6f6f6; 
  color: #666; 
  border: 1px solid #d9d9d9; 
}

.pending-status { 
  background: #fffbe6; 
  color: #faad14; 
  border: 1px solid #ffe58f; 
}

/* Table styling */
.appointment-table .ant-table-thead > tr > th {
  background: #fafafa;
  font-weight: 600;
  color: #262626;
  padding: 16px 12px;
  border-bottom: 2px solid #f0f0f0;
}

.appointment-table .ant-table-tbody > tr > td {
  padding: 12px;
  border-bottom: 1px solid #f0f0f0;
  transition: all 0.3s ease;
}

.appointment-table .ant-table-tbody > tr:hover > td {
  background: #fafafa;
}

.appointment-table .ant-table-tbody > tr:last-child > td {
  border-bottom: none;
}

/* Responsive adjustments */
@media (max-width: 768px) {
  .appointment-report-container {
    padding: 16px;
  }
  
  .controls-section,
  .table-section {
    padding: 16px;
  }
  
  .page-header h1 {
    font-size: 20px;
  }
}

@media (max-width: 576px) {
  .appointment-report-container {
    padding: 12px;
  }
  
  .controls-section,
  .table-section {
    padding: 12px;
  }
}

`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AASA;EACE,kCAAkC;EAClC,sBAAsB;EACtB,0BAA0B;;AAE5B;;;;AAIA;EACE,uBAAuB;AACzB;;AAEA;EACE,kCAAkC;EAClC,gBAAgB;EAChB,sBAAsB;EACtB,0BAA0B;;;AAG5B;;;AAGA;EACE,SAAS;EACT,UAAU;EACV,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,uBAAuB;EACvB,kBAAkB;AACpB;AACA;EACE,eAAe;EACf,kBAAkB;AACpB;AACA;EACE,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,4BAA4B;AAC9B;;;AAGA;EACE,6BAA6B;IAC3B,0CAA0C;AAC9C;;;;AAIA;IACI,qBAAqB;IACrB,gBAAgB;AACpB;;;;;;;;AAQA;EACE,kCAAkC;EAClC,gBAAgB;EAChB,sBAAsB;EACtB,0BAA0B;;;AAG5B;;;AAGA;GACG,kCAAkC;EACnC,gBAAgB;EAChB,sBAAsB;EACtB,0BAA0B;;;AAG5B;;AAEA;GACG,kCAAkC;EACnC,gBAAgB;EAChB,sBAAsB;;AAExB;;AAEA;GACG,kCAAkC;EACnC,gBAAgB;EAChB,sBAAsB;EACtB,0BAA0B;AAC5B;;AAEA;GACG,kCAAkC;EACnC,sBAAsB;AACxB;;;AAGA;EACE,SAAS;EACT,UAAU;EACV,WAAW;EACX,YAAY;EACZ,gBAAgB,EAAE,yCAAyC;;AAE7D;;;;;AAKA,mBAAmB;AACnB;EACE,cAAc;EACd,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,iBAAiB;;;AAGnB;;AAEA;EACE,4CAA4C;EAC5C,yBAAyB;EACzB,6BAA6B;EAC7B,6BAA6B;AAC/B;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,sCAAsC;EACtC,eAAe;EACf,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,uBAAuB;AACzB;;AAEA,iCAAiC;;;;;;;AAOjC;EACE,aAAa;EACb,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,oCAAoC;EACpC,yDAA8D,EAAE,gCAAgC;EAChG,sBAAsB;EACtB,2BAA2B;EAC3B,8BAA8B,EAAE,gDAAgD;EAChF,YAAY,EAAE,6BAA6B;EAC3C,gBAAgB;AAClB;;;;;AAKA;EACE,cAAc;EACd,oCAAoC;EACpC,eAAe;EACf,iCAAiC;EACjC,kBAAkB;EAClB,kBAAkB;EAClB,8BAA8B;AAChC;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,uBAAuB;EACvB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,YAAY;IACV,oCAAoC;IACpC,6BAA6B;AACjC;;AAEA,mBAAmB;AACnB;EACE,6BAA6B;EAC7B,uBAAuB;EACvB,sBAAsB;EACtB,4BAA4B;AAC9B;;AAEA;EACE,2BAA2B;EAC3B,sBAAsB;EACtB,2BAA2B;;AAE7B;;AAEA;;EAEE,2BAA2B;EAC3B,uBAAuB;;EAEvB;;AAEF;;;EAGE,2BAA2B;;AAE7B;;;;AAIA;;;EAGE,sBAAsB;EACtB,0BAA0B;EAC1B,uBAAuB;EACvB,sBAAsB;AACxB;;AAEA;EACE,0BAA0B;EAC1B,4BAA4B;EAC5B,2BAA2B;EAC3B,qCAAqC;EACrC,eAAe;AACjB;;AAEA;EACE,uBAAuB;EACvB,sBAAsB;AACxB;;AAEA;EACE,qCAAqC;EACrC,uBAAuB;AACzB;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,6BAA6B;AAC/B;AACA;;;;;;;;;IASI;;AAEJ;EACE,uBAAuB;EACvB,wCAAwC;EACxC,0BAA0B;EAC1B,iCAAiC;EACjC,2BAA2B;;AAE7B;;AAEA;EACE,6BAA6B;EAC7B,uBAAuB;EACvB,wCAAwC;EACxC,0BAA0B;EAC1B,iCAAiC;EACjC,2BAA2B;;AAE7B;;AAEA;EACE,0BAA0B;EAC1B,2BAA2B;EAC3B,0BAA0B;AAC5B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,mCAAmC;EACnC,gCAAgC;EAChC,uBAAuB;EACvB,2BAA2B;EAC3B,sBAAsB;EACtB,uBAAuB;EACvB,2BAA2B;EAC3B,8BAA8B;EAC9B,2BAA2B;AAC7B;;AAEA;IACI,WAAW;GACZ,mCAAmC;EACpC,gCAAgC;AAClC;;;AAGA;EACE,oCAAoC;EACpC,gCAAgC;EAChC,sBAAsB;AACxB;;;AAGA;;EAEE,uBAAuB;EACvB,yBAAyB;EACzB,2BAA2B;EAC3B,sBAAsB;EACtB,uBAAuB;EACvB,2BAA2B;EAC3B,8BAA8B;EAC9B,2BAA2B;;AAE7B;;AAEA;EACE,qCAAqC;EACrC,iCAAiC;EACjC,uBAAuB;AACzB;;AAEA;EACE,8BAA8B;EAC9B,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,sCAAsC;EACtC,sBAAsB;EACtB,qBAAqB;AACvB;;AAEA;EACE,4BAA4B;EAC5B,6BAA6B;AAC/B;;;AAGA;EACE,aAAa;EACb,iBAAiB;EACjB,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,wCAAwC;EACxC,aAAa;AACf;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,8BAA8B;AAChC;;;AAGA;EACE,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,iBAAiB;GAChB,6BAA6B;;;;AAIhC;;AAEA;EACE;IACE,oBAAoB,EAAE,sBAAsB;EAC9C;AACF;;;AAGA;EACE,uBAAuB;EACvB,wCAAwC;EACxC,0BAA0B;EAC1B,iCAAiC;EACjC,6BAA6B;;AAE/B;;;;AAIA;EACE,uBAAuB;EACvB,oCAAoC;EACpC,2BAA2B;EAC3B,6BAA6B;AAC/B;;;AAGA;EACE,aAAa;EACb,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,kBAAkB;EAClB,mBAAmB;EACnB,yCAAyC;AAC3C;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,kBAAkB;EAClB,yCAAyC;AAC3C;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,yBAAyB;AAC3B;;AAEA,kBAAkB;AAClB;EACE,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,gCAAgC;EAChC,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA,2BAA2B;AAC3B;EACE;IACE,aAAa;EACf;;EAEA;;IAEE,aAAa;EACf;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;;IAEE,aAAa;EACf;AACF","sourcesContent":["@import url(\"https://fonts.googleapis.com/css2?family=Montserrat+Alternates:wght@100;200;500&family=Roboto+Condensed:wght@100;500&display=swap\");\n@import url('https://fonts.googleapis.com/css2?family=Roboto+Condensed:ital,wght@0,100..900;1,100..900&display=swap');\n@import url('https://fonts.googleapis.com/css2?family=Inter:wght@400;700&display=swap');\n@import url('https://fonts.googleapis.com/css2?family=Poppins:wght@100;200;300;400;500;600;700;800;900&display=swap');\n\n\n\n\n\n* {\n  font-family: 'Poppins', sans-serif;\n  box-sizing: border-box;\n  font-size: 16px !important;\n\n}\n\n\n\n.p-card{\n  color: white !important;;\n}\n\nh1,h2 {\n  font-family: 'Poppins', sans-serif;\n  font-weight: 500;\n  box-sizing: border-box;\n  font-size: 50px !important;\n\n\n}\n\n\n.events {\n  margin: 0;\n  padding: 0;\n  list-style: none;\n}\n.events .ant-badge-status {\n  width: 100%;\n  overflow: hidden;\n  font-size: 12px;\n  white-space: wrap;\n  text-overflow: ellipsis;\n  text-align: center;\n}\n.notes-month {\n  font-size: 28px;\n  text-align: center;\n}\n.notes-month section {\n  font-size: 28px;\n}\n\n.ant-rate {\n  gap: 1px !important;\n}\n\n.ant-rate .ant-rate-star {\n  margin-inline-end: 1px !important;\n}\n\n.ant-rate {\n  margin-right: 2px !important;\n}\n\n\n:where(.css-dev-only-do-not-override-7ny38l).ant-btn-color-primary{\n  background: #379777!important;\n    box-shadow: 0 2px 0 rgba(5, 145, 255, 0.1);\n}\n\n\n\n:where(.css-dev-only-do-not-override-7ny38l).ant-btn-variant-link {\n    color:white!important;\n    box-shadow: none;\n}\n\n\n\n\n\n\n\nh2 {\n  font-family: 'Poppins', sans-serif;\n  font-weight: 500;\n  box-sizing: border-box;\n  font-size: 30px !important;\n\n\n}\n\n\nh3,h4,h5 {\n   font-family: 'Poppins', sans-serif;\n  font-weight: 500;\n  box-sizing: border-box;\n  font-size: 18px !important;\n\n\n}\n\np {\n   font-family: 'Poppins', sans-serif;\n  font-weight: 400;\n  box-sizing: border-box;\n\n}\n\na{\n   font-family: 'Poppins', sans-serif;\n  font-weight: 500;\n  box-sizing: border-box;\n  font-size: 18px !important;\n}\n\ninput {\n   font-family: 'Poppins', sans-serif;\n  box-sizing: border-box;\n}\n\n\nhtml, body {\n  margin: 0;\n  padding: 0;\n  width: 100%;\n  height: 100%;\n  overflow: hidden; /* Prevents scrolling on the whole page */\n\n}\n\n\n\n\n/* Common styling */\n.cards-title {\n  font-size: 3em;\n  font-weight: bold;\n  margin-bottom: 0px;\n}\n\n.normal-text {\n  font-size: 1rem;\n}\n\n.normal-text-doctor-speciality{\n  font-size: 1rem;\n  margin-top:-200px;\n\n  \n}\n\n.card {\n  box-shadow: 0 0 1px 1px rgba(0, 0, 0, 0.007);\n  margin: 15px 0 !important;\n  border-radius: 0px !important;\n  padding: 10px 20px !important;\n}\n\n.cursor-pointer {\n  cursor: pointer;\n}\n\nh1.card-t {\n  font-size: 1.7rem;\n  font-weight: 500;\n  color: white !important;\n}\n\n.spinner-parent {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  background-color: rgba(0, 0, 0, 0.452);\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  z-index: 9999;\n}\n\n.spinner-border {\n  width: 5rem;\n  height: 5rem;\n  color: white !important;\n}\n\n/* Authentication pages styling */\n\n\n\n\n\n\n.auth {\n  height: 100vh;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  background-color: #1e2d3b !important;\n  background-image: url('./components/image/appointmentbk.jpeg'); /* Replace with your image URL */\n  background-size: cover;\n  background-position: center;\n  background-blend-mode:multiply; /* Choose the blend mode that suits your needs */\n  opacity: 1.1; /* Adjust opacity as needed */\n  overflow-y: auto;\n}\n\n\n\n\n.auth .card-title {\n  font-size: 1em;\n  background-color:  #217559!important;\n  color:  #1e2d3b;\n  max-width: max-content !important;\n  padding:  7px 15px;\n  margin-left: -40px;\n  border-bottom-left-radius: 8px;\n}\n\n.cn {\n  text-align: center !important;\n}\n\n.title {\n  justify-content: center;\n  margin: 0 auto;\n  align-items: center;\n}\n\n.auth-form {\n  width: 100%;\n  max-width:450px;\n  padding: 5px;\n    background-color: #fafdff !important;\n    border-radius: 5px !important;\n}\n\n/* antd overrides */\ninput {\n  border-radius: 6px !important;\n  height: 40px !important;\n  width: 100% !important;\n  padding: 0px 11px !important;\n}\n\n:where(.css-dev-only-do-not-override-dkbvqv).ant-input-affix-wrapper {\n  border-radius: 0 !important;\n  height:40px !important;\n  padding: px 11px !important;\n  \n}\n\n:where(.css-dev-only-do-not-override-1pg9a38).ant-input-affix-wrapper \n{\n  border-radius: 0 !important;\n  height: 40px !important;\n  \n  }\n\n:where(.css-dev-only-do-not-override-1pg9a38).ant-input-affix-wrapper \n\n.ant-btn {\n  border-radius: 0 !important;\n  \n}\n\n\n\n:where(.css-dev-only-do-not-override-dkbvqv).ant-picker\n  .ant-picker-input\n  > input {\n  border: 0px !important;\n  color:  #1e2d3b !important;\n  height: 50px !important;\n  width: 100% !important;\n}\n\n.anchor {\n  color:  #1e2d3b !important;\n  font-size: 0.9rem !important;\n  font-weight: 500 !important;\n  text-decoration: underline !important;\n  cursor: pointer;\n}\n\n:where(.css-dev-only-do-not-override-dkbvqv).ant-picker {\n  height: 40px !important;\n  width: 100% !important;\n}\n\n:where(.css-dev-only-do-not-override-dkbvqv).ant-btn-primary {\n  background-color:  #1e2d3b !important;\n  color: white !important;\n}\n\n.ant-picker {\n  border-radius: 0px !important;\n}\n\n.ant-select-selector {\n  border-radius: 0px !important;\n}\n/* input.ant-input{\n  border:0px!important;\n  border-radius: 0px !important;\n  height:40px !important;\n  background-color:transparent !important;\n  font-size: 15px !important;\n  color:rgb(24, 23, 23) !important;\n  padding: 0px 3px !important;\n \n}  */\n\n.ant-select-selector {\n  height: 50px !important;\n  background-color: transparent !important;\n  font-size: 15px !important;\n  color: rgb(24, 23, 23) !important;\n  padding: 0px 3px !important;\n\n}\n\n.ant-select-selection-search-input {\n  border-radius: 0px !important;\n  height: 50px !important;\n  background-color: transparent !important;\n  font-size: 15px !important;\n  color: rgb(24, 23, 23) !important;\n  padding: 0px 3px !important;\n\n}\n\nlabel {\n  font-size: 1rem !important;\n  font-weight: 400 !important;\n  color:  #1e2d3b !important;\n}\n\n.ant-form-item {\n  margin: 15px 0 !important;\n}\n\n.btn-primary {\n  background-color: #217559!important;\n  border-color:  #217559!important;\n  color: white !important;\n  font-weight: 500 !important;\n  width: 100% !important;\n  height: 40px !important;\n  margin-top: 10px !important;\n  margin-bottom: 10px !important;\n  border-radius: 0 !important;\n}\n\n:where(.css-dev-only-do-not-override-1odpy5d).ant-btn-variant-solid {\n    color: #fff;\n   background-color: #217559!important;\n  border-color:  #217559!important;\n}\n\n\n.btn-primary:hover {\n  background-color: #1e2d3b !important;\n  border-color: #1e2d3b !important;\n  color:white !important;\n}\n\n\n.btn-2{\n\n  border: none !important;\n  color: #1e2d3b !important;\n  font-weight: 500 !important;\n  width: 100% !important;\n  height: 40px !important;\n  margin-top: 10px !important;\n  margin-bottom: 10px !important;\n  border-radius: 0 !important;\n\n}\n\n.btn-2:hover {\n  background-color:  #1e2d3b !important;\n  border-color:  #1e2d3b !important;\n  color: white !important;\n}\n\n.formFactor {\n  justify-content: space-between;\n  align-items: center;\n  margin: 0px 30px;\n}\n\n.mv {\n  margin: 0 30px;\n}\n\n.page-header {\n  margin: 0 30px;\n}\n\n.page-title {\n  font-size: 0.9rem;\n}\n\n.card-title {\n  font-size: 1rem;\n  font-weight: 900;\n  color: white !important;\n}\n\np {\n  color: rgba(0, 0, 0, 0.773) !important;\n  margin: 3px !important;\n  padding: 0 !important;\n}\n\n.pm{\n  text-align: center!important;\n  align-items: center!important;\n}\n\n\n.book-appointment-container {\n  padding: 20px;\n  max-width: 1200px;\n  margin: auto;\n}\n\n.doctor-card {\n  background: #f9f9f9;\n  border-radius: 10px;\n  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);\n  padding: 20px;\n}\n\n.book-now-img {\n  border-radius: 10px;\n  margin-bottom: 20px;\n}\n\n.descriptions {\n  margin-bottom: 20px;\n}\n\n.date-time-picker {\n  display: flex;\n  align-items: center;\n  margin-bottom: 10px;\n  margin-top: 20px;\n}\n\n.button-group {\n  display: flex;\n  justify-content: space-between;\n}\n\n\n.ant-picker{\n  width: 100%;\n  height: 40px;\n  margin-left: 6px;\n  margin-right: 6px;\n   border-radius: 6px !important;\n\n\n\n}\n\n@media (max-width: 768px) {\n  .auth {\n    padding-bottom: 2rem; /* space for content */\n  }\n}\n\n\n.ant-select-selector {\n  height: 40px !important;\n  background-color: transparent !important;\n  font-size: 15px !important;\n  color: rgb(24, 23, 23) !important;\n  border-radius: 6px !important;\n\n}\n\n\n\n:where(.css-dev-only-do-not-override-7ny38l).ant-btn-color-dangerous.ant-btn-variant-link{\n  color: white !important;\n  background-color: #f5222d !important;\n  box-shadow: none !important;\n  border-radius: 6px !important;\n}\n\n\n.appointment-report-container {\n  padding: 20px;\n  min-height: 100vh;\n  background: #f0f2f5;\n}\n\n.page-header {\n  margin-bottom: 24px;\n}\n\n.page-header h1 {\n  margin: 0;\n  color: #262626;\n  font-size: 24px;\n  font-weight: 600;\n}\n\n.page-header p {\n  margin: 4px 0 0 0;\n  color: #8c8c8c;\n  font-size: 14px;\n}\n\n.controls-section {\n  background: white;\n  padding: 20px;\n  border-radius: 8px;\n  margin-bottom: 20px;\n  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.03);\n}\n\n.table-section {\n  background: white;\n  padding: 20px;\n  border-radius: 8px;\n  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.03);\n}\n\n.comment-cell {\n  max-width: 150px;\n}\n\n.comment-by {\n  font-weight: 600;\n  font-size: 12px;\n  color: #1890ff;\n  margin-bottom: 2px;\n}\n\n.comment-text {\n  font-size: 11px;\n  color: #666;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.action-display {\n  font-size: 12px;\n}\n\n.action-info {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  margin-bottom: 4px;\n}\n\n.action-time {\n  font-size: 11px;\n  color: #999;\n  padding-left: 20px;\n}\n\n.status-indicator {\n  padding: 4px 8px;\n  border-radius: 4px;\n  font-size: 12px;\n  font-weight: 500;\n  display: inline-block;\n}\n\n.approved-status { \n  background: #f6ffed; \n  color: #52c41a; \n  border: 1px solid #b7eb8f; \n}\n\n.rejected-status { \n  background: #fff2f0; \n  color: #ff4d4f; \n  border: 1px solid #ffccc7; \n}\n\n.followup-status { \n  background: #f0f7ff; \n  color: #1890ff; \n  border: 1px solid #91d5ff; \n}\n\n.completed-status { \n  background: #f6f6f6; \n  color: #666; \n  border: 1px solid #d9d9d9; \n}\n\n.pending-status { \n  background: #fffbe6; \n  color: #faad14; \n  border: 1px solid #ffe58f; \n}\n\n/* Table styling */\n.appointment-table .ant-table-thead > tr > th {\n  background: #fafafa;\n  font-weight: 600;\n  color: #262626;\n  padding: 16px 12px;\n  border-bottom: 2px solid #f0f0f0;\n}\n\n.appointment-table .ant-table-tbody > tr > td {\n  padding: 12px;\n  border-bottom: 1px solid #f0f0f0;\n  transition: all 0.3s ease;\n}\n\n.appointment-table .ant-table-tbody > tr:hover > td {\n  background: #fafafa;\n}\n\n.appointment-table .ant-table-tbody > tr:last-child > td {\n  border-bottom: none;\n}\n\n/* Responsive adjustments */\n@media (max-width: 768px) {\n  .appointment-report-container {\n    padding: 16px;\n  }\n  \n  .controls-section,\n  .table-section {\n    padding: 16px;\n  }\n  \n  .page-header h1 {\n    font-size: 20px;\n  }\n}\n\n@media (max-width: 576px) {\n  .appointment-report-container {\n    padding: 12px;\n  }\n  \n  .controls-section,\n  .table-section {\n    padding: 12px;\n  }\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
